exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sD6z57Siv6aWqmrd8sfg-{cursor:pointer;position:absolute;right:10px;top:10px;color:#999}\n", ""]);

// Exports
exports.locals = {
	"closeButton": "sD6z57Siv6aWqmrd8sfg-"
};